<template>
  <div class="loading-indicator__container">
    <div class="loading-indicator__img"></div>
    <div>분석중입니다!</div>
    <div class="loading-indicator__tip">TIP</div>
    <div class="loading-indicator__tip-text">
      당일 운세 확인은<br>3개까지 무료로 제공돼요!
    </div>
  </div>
</template>

<style scoped>
.loading-indicator__container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--Gray-800, #333);
  text-align: center;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
}
.loading-indicator__img {
  margin-bottom: 20px;
  width: 310px;
  height: 77px;
  background: url('/src/assets/images_manse/loadingIndiactor.gif') no-repeat;
  background-size: contain;
}
.loading-indicator__tip {
  margin-top: 40px;
  width: fit-content;
  display: flex;
  padding: 2px 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 16px;
  background: var(--orange-300-main, #EB4C10);
  color: var(--gray-100-white, #FFF);
  font-family: Pretendard;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
}
.loading-indicator__tip-text {
  margin-top: 8px;
  color: var(--Gray-700, #575757);
  text-align: center;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
}
</style>